<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'维度分组-'+modalData.title"
        :show-close="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" :rules="rules"  label-width="100px" class="pr40">
                <el-form-item v-if="modalData.name=='date'" prop="sum_type" label="汇总方式" class="label-required">
                    <el-select v-model="formItem.sum_type" @change="changeSumType" placeholder="请选择">
                        <el-option label="天" value="day"></el-option>
                        <el-option label="周" value="week"></el-option>
                        <el-option label="月" value="month"></el-option>
                        <el-option label="季度" value="quarter"></el-option>
                        <el-option label="年" value="year"></el-option>
                    </el-select>
                    <span v-if="formItem.sum_type=='week'&&weekTips" class="font12px ml10">当前周定义为：{{ weekTips }}</span>
                </el-form-item>
                <el-form-item v-if="modalData.name=='yy_type'" prop="start_date_dimension" label="运营类型维度" class="label-required">
                    <ESelect v-model="formItem.yy_type_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in yyTypeDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item v-if="modalData.name=='start_date'" prop="start_date_dimension" label="开投日期维度" class="label-required">
                    <ESelect v-model="formItem.start_date_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in dimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item v-else-if="modalData.name=='create_date'" prop="create_date_dimension" label="创建日期维度" class="label-required">
                    <ESelect v-model="formItem.create_date_dimension" @change="checkAppleSelect" placeholder="请选择">
                        <el-option
                            v-for="item in createDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="排序条件" prop="order_by" :class="modalData.name=='date'?'label-required':''">
                    <ESelect v-model="formItem.order_by" @change="changeOrderBy" @clear="clearOrderBy" clearable filterable placeholder="请选择">
                        <el-option value="date" label="数据日期" v-if="modalData.name=='date'"></el-option>
                        <el-option value="time_interval" label="数据时段" v-if="modalData.name=='time_interval'"></el-option>
                        <el-option
                            v-for="item in platAvailableFieldList"
                            :key="item.name"
                            :label="item.display_name"
                            :disabled="isCompare&&item.isSumField"
                            :title="isCompare&&item.isSumField?'累计指标对比时维度排序':''"
                            :value="item.name">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <template v-if="modalData.name=='date'||formItem.order_by">
                    <el-form-item label="排序方式" prop="order_type" class="label-required">
                        <el-radio v-model="formItem.order_type" label="desc">降序</el-radio>
                        <el-radio v-model="formItem.order_type" label="asc">升序</el-radio>
                    </el-form-item>
                    <el-form-item v-if="modalData.name!='date'" label="展示数量" prop="show_num" class="label-required">
                        <el-radio v-model="formItem.show_type" label="1">全部</el-radio>
                        <el-radio v-model="formItem.show_type" label="2">自定义<span v-if="formItem.show_type==2" class="pl6 text-color-gray">输入要展示的数量</span></el-radio>
                        <p class="ml80">
                            <el-input-number v-if="formItem.show_type=='2'" v-model="formItem.show_num" size="mini" controls-position="right" :min="1" :step="1" placeholder="输入要展示的数量"></el-input-number>
                        </p>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "DimensionModal",
        components: {},
        props: {
            modalData:{
                type:Object,
                required:true,
            },
            shownField:{
                type:Array,
                required: true,
            },
            hiddenField:{
                type:Array,
                required: true,
            },
            dimensions:{
                type:Array,
                required: true,
            },
            condition:{
                type:Array,
                required: true,
            },
            allField:{
                type:Array,
                required: true,
            },
            platId:[String,Number],
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            appleAdFieldList:Array,
            appleKeywordsFieldList:Array,
        },
        data() {
            return {
                dialogVisible: false,
                formItem: {
                    sum_type:'',    // 汇总方式
                    start_date_dimension:'',        //开投日期维度:取维度字段，默认按产品
                    create_date_dimension:'account_create_time',        //创建日期维度:取维度字段
                    yy_type_dimension:'bloc_yy_type',       // 运营类型维度:取维度字段
                    order_by:'',    // 排序条件
                    order_type:'desc',    // 排序方式
                    show_type:'1',    // 展示数量方式 1-全部，2-自定义
                    show_num:null,    // 展示数量
                },
                rules: {
                    sum_type: [],
                    start_date_dimension: [],
                    order_by: [],
                    order_type: [],
                    show_num: [],
                },
                dimensionList:[],
                createDimensionList:[],
                yyTypeDimensionList:[],
                allFieldList:[],
                lastSelectVal:'',
            }
        },
        computed: {
            ...mapState({
                pageConfig:state => state.user.page_config,
            }),
            weekConfig(){
                return this.pageConfig.data_query_analysis_week_mode||'';
            },
            weekTips(){
                if(!this.weekConfig) return '';
                let weekMap = {
                    1:'【周一到周日】为一周',
                    2:'【周二到周一】为一周',
                    3:'【周三到周二】为一周',
                    4:'【周四到周三】为一周',
                    5:'【周五到周四】为一周',
                    6:'【周六到周五】为一周',
                    7:'【周日到周六】为一周',
                }
                return weekMap[this.weekConfig];
            },
            availableFieldList(){
                if(!this.isTimeFilter) return this.allFieldList;
                if(this.isCompare&&!this.isTimeFilter){
                    return this.allFieldList;
                }
                return this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour'));
            },
            platAvailableFieldList(){
                return this.availableFieldList.filter(item=>{
                    if(this.platId=='9'){
                        return !['impression_share','impression_rank','search_popularity',].includes(item.name);
                    }else{
                        return this.availableFieldList;
                    }
                })
            },
            isPlatAll(){
                return this.$route.name==='data_all';
            },
        },
        mounted(){
            this.formItem.start_date_dimension = this.isPlatAll?'subproject_name':'app_name'
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.$nextTick(()=>{
                    this.resetForm();
                })
            },
            resetForm() {
                this.formItem.sum_type = '';
                this.formItem.start_date_dimension = this.isPlatAll?'subproject_name':'app_name';
                this.formItem.create_date_dimension = this.platId=='9'?'plan_create_date':'account_create_time';
                this.formItem.yy_type_dimension = 'bloc_yy_type';
                this.formItem.order_by = '';
                this.formItem.order_type = 'desc';
                this.formItem.show_type = '1';
                this.formItem.show_num = null;
                this.$refs['form'].resetFields();
            },
            makeDimensionList(){
                if(this.isPlatAll){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        // {
                        //     display_name:'按广告',
                        //     name:'ad_name',
                        // },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        // {
                        //     display_name:'按广告',
                        //     name:'ad_create_date',
                        // },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        // {
                        //     name:'ad_yy_type',
                        //     display_name:'按广告',
                        // },
                    ];
                }else if(this.platId=='3'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'idea_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='4'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按任务',
                            name:'task_name',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按任务',
                            name:'task_create_date',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按账户',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按任务',
                            name:'task_yy_type',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_yy_type',
                        },
                    ];
                }else if(this.platId=='8'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按广告系列',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];

                } else if(this.platId=='9'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword',
                        },
                        {
                            display_name:'按搜索词',
                            name:'search_term',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.createDimensionList = [
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_yy_type',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_yy_type',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_yy_type',
                        },
                    ];
                }else if(this.platId=='7'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='12'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        // {
                        //     display_name:'按账户',
                        //     name:'account_create_time',
                        // },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='37'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }
                else if(this.platId=='10'||this.platId=='11') {
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:this.platId=='11'?'按分组':'按任务',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:this.platId=='11'?'按分组':'按任务',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        }
                    ];
                    this.yyTypeDimensionList = [
                         {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:this.platId=='11'?'按分组':'按任务',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else{
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }
            },
            showModal() {
                this.dialogVisible = true;
                this.makeDimensionList();

                let modalVal = this.modalData.dimensionValue||{};
                this.formItem.sum_type = this.modalData.name=='date'?modalVal.sum_type:'';
                this.formItem.start_date_dimension = this.modalData.name=='start_date'?modalVal.start_date_dimension||(this.isPlatAll?'subproject_name':'app_name'):'';
                this.formItem.create_date_dimension = this.modalData.name=='create_date'?modalVal.create_date_dimension||'account_create_time':'';
                this.formItem.yy_type_dimension = this.modalData.name=='yy_type'?modalVal.yy_type_dimension||'bloc_yy_type':'';
                this.formItem.order_by = modalVal.order_by||(this.modalData.name=='date'?'date':this.modalData.name=='time_interval'?'time_interval':'');
                this.formItem.order_type = modalVal.order_type||'desc';
                this.formItem.show_type = modalVal.show_type||'1';
                this.formItem.show_num = modalVal.show_num||null;

                if(this.modalData.name=='start_date'){
                    this.lastSelectVal = this.formItem.start_date_dimension;
                }else if(this.modalData.name=='create_date'){
                    this.lastSelectVal = this.formItem.create_date_dimension;
                }else if(this.modalData.name=='yy_type'){
                    this.lastSelectVal = this.formItem.yy_type_dimension;
                }


                this.$nextTick(()=>{
                    let checkedData = [].concat(this.shownField,this.hiddenField);

                    let flatData = [];
                    this.allField.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            flatData = flatData.concat(item.children.map(inner=>{
                                if(item.name.includes('_sum_data')){
                                    inner.isSumField = true;
                                }
                                return inner;
                            }));
                        }
                    });

                    flatData.forEach(item=>{
                        if(checkedData.findIndex(inner=>inner.name==item.name)===-1){
                            checkedData.push(item);
                        }
                    });
                    this.allFieldList = checkedData;
                })
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        let dimensionSortCount = 0;
                        this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                            if(item.name==='date'||item.name==='time_interval'){
                                dimensionSortCount++
                            }else{
                                let dimensionValue = item.dimensionValue||{};
                                if(dimensionValue.order_by!=''){
                                    dimensionSortCount++
                                }
                            }
                        });

                        if(this.formItem.order_by&&dimensionSortCount>10){
                            return this.$message.error('最多可设置10个维度的排序');
                        }


                        let data={
                            order_by: this.formItem.order_by,
                            order_type: this.formItem.order_by?this.formItem.order_type:'',
                            show_num: this.formItem.order_by?this.formItem.show_num:'',
                            show_type: this.formItem.order_by?this.formItem.show_type:'',
                            start_date_dimension:this.formItem.start_date_dimension,
                            create_date_dimension:this.formItem.create_date_dimension,
                            yy_type_dimension:this.formItem.yy_type_dimension,
                            sum_type: this.formItem.sum_type,
                        };
                        this.$emit('save-value',this.modalData,data);
                        this.$nextTick(()=>{
                            this.handleClose();
                        })
                    } else {
                        return false;
                    }
                });
            },
            clearOrderBy(){
                if(this.modalData.name=='date'){
                    this.formItem.order_by = 'date';
                }else if(this.modalData.name=='time_interval'){
                    this.formItem.order_by = 'time_interval';
                }
            },
            changeOrderBy(val){
                /* 判断维度中有排序的个数，超过10个后禁止设置 */
                let dimensionSortCount = 0;
                this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                    if(item.name==='date'||item.name==='time_interval'){
                        dimensionSortCount++
                    }else{
                        let dimensionValue = item.dimensionValue||{};
                        if(dimensionValue.order_by!=''){
                            dimensionSortCount++
                        }
                    }
                });
                if(val&&dimensionSortCount>=10){
                    this.$message.error('最多可设置10个维度的排序');
                    if(this.modalData.name!='date'&&this.modalData.name!='time_interval'){
                        this.formItem.order_by = '';
                    }
                }
            },
            changeSumType(){
                // this.$emit('change-sum-type');
            },
            checkAppleSelect(val){
                if(this.platId!='9') return false;

                let formGroup = (this.dimensions||[]).filter(item=>item.name!=this.modalData.name);
                let formCondition = this.condition||[];
                let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                let groupStartDate = formGroup.find(item=>item.name=='start_date');
                let groupYYType = formGroup.find(item=>item.name=='yy_type');
                let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';
                let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';
                let adFieldList = this.appleAdFieldList;
                let isGroupHasAd = formGroup.map(item=>item.name).some(item=>adFieldList.includes(item));

                let isConditionHasAd = formCondition.map(item=>item.name).some(item=>adFieldList.includes(item));
                let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                let conditionStartDate = formCondition.find(item=>item.name=='start_date');
                let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';
                let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';

                let keywordsFieldList = this.appleKeywordsFieldList;
                let isGroupHasKeywords = formGroup.map(item=>item.name).some(item=>keywordsFieldList.includes(item));
                let isConditionHasKeywords = formCondition.map(item=>item.name).some(item=>keywordsFieldList.includes(item));

                let isAppleAdChecked = isGroupHasAd||isGroupCreateDateAd||isGroupStartDateAd||isConditionHasAd||isConditionCreateDateAd||isConditionStartDateAd;
                let isAppleKeywordsChecked = isGroupHasKeywords||isGroupYYTypeKeywords||isGroupCreateDateKeywords||isGroupStartDateKeywords||isGroupStartDateSearchTerm||isConditionHasKeywords||isConditionYYTypeKeywords||isConditionCreateDateKeywords||isConditionStartDateKeywords||isConditionStartDateSearchTerm;

                if(isAppleAdChecked&&(val=='keyword'||val=='search_term'||val=='keyword_create_date'||val=='keyword_yy_type')){
                    /* 页面已选广告相关，维度弹窗里又选了关键字 */
                    let groupAdList = [];
                    let conditionAdList = [];
                    this.dimensions.forEach(item=>{
                        if(this.appleAdFieldList.includes(item.name)){
                            groupAdList.push({...item});
                        }
                    });
                    this.condition.forEach(item=>{
                        if(this.appleAdFieldList.includes(item.name)){
                            conditionAdList.push({...item});
                        }
                    });


                    let groupTextList = groupAdList.map(item=>item.display_name);
                    let conditionTextList = conditionAdList.map(item=>item.display_name);
                    let restGroup = [];
                    let restCondition = [];

                    if(isGroupCreateDateAd){
                        groupTextList.push('创建日期(按广告)');
                        restGroup.push('create_date');
                    }
                    if(isGroupStartDateAd){
                        groupTextList.push('开投日期(按广告)');
                        restGroup.push('start_date');
                    }
                    if(isConditionCreateDateAd){
                        conditionTextList.push('创建日期(按广告)');
                        restCondition.push('create_date');
                    }
                    if(isConditionStartDateAd){
                        conditionTextList.push('开投日期(按广告)');
                        restCondition.push('start_date');
                    }


                    let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                    let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                    let htmlStr = `<div><p>关键词相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                    this.$confirm(htmlStr,'提示',{
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        customClass:'wide-confirm-box-550',
                    }).then(()=>{
                        console.log('继续');
                        this.lastSelectVal = val;
                        this.$emit('remove-apple-form',groupAdList.map(item=>item.name).concat(restGroup),conditionAdList.map(item=>item.name).concat(restCondition));
                    }).catch(()=>{
                        console.log('取消');
                        if(this.modalData.name=='start_date'){
                            this.$set(this.formItem,'start_date_dimension',this.lastSelectVal);
                        }else if(this.modalData.name=='create_date'){
                            this.$set(this.formItem,'create_date_dimension',this.lastSelectVal);
                        }else if(this.modalData.name=='yy_type'){
                            this.$set(this.formItem,'yy_type_dimension',this.lastSelectVal);
                        }

                    })

                }else if(isAppleKeywordsChecked&&(val=='ad_name'||val=='ad_create_date')){
                    /* 页面已选关键字相关，维度弹窗里又选了广告 */

                    let groupKeywordList = [];
                    let conditionKeywordList = [];
                    formGroup.forEach(item=>{
                        if(this.appleKeywordsFieldList.includes(item.name)){
                            groupKeywordList.push({...item});
                        }
                    });
                    formCondition.forEach(item=>{
                        if(this.appleKeywordsFieldList.includes(item.name)){
                            conditionKeywordList.push({...item});
                        }
                    });


                    let groupTextList = groupKeywordList.map(item=>item.display_name);
                    let conditionTextList = conditionKeywordList.map(item=>item.display_name);
                    let restGroup = [];
                    let restCondition = [];
                    if(isGroupYYTypeKeywords){
                        groupTextList.push('运营类型(关键词)');
                        restGroup.push('yy_type');
                    }
                    if(isGroupCreateDateKeywords){
                        groupTextList.push('创建日期(关键词)');
                        restGroup.push('create_date');
                    }
                    if(isGroupStartDateKeywords){
                        groupTextList.push('开投日期(关键词)');
                        restGroup.push('start_date');
                    }
                    if(isGroupStartDateSearchTerm){
                        groupTextList.push('开投日期(搜索词)');
                        if(!restGroup.includes('start_date')){
                            restGroup.push('start_date');
                        }
                    }

                    if(isConditionYYTypeKeywords){
                        conditionTextList.push('运营类型(关键词)');
                        restCondition.push('yy_type');
                    }
                    if(isConditionCreateDateKeywords){
                        conditionTextList.push('创建日期(关键词)');
                        restCondition.push('create_date');
                    }
                    if(isConditionStartDateKeywords){
                        conditionTextList.push('开投日期(关键词)');
                        restCondition.push('start_date');
                    }
                    if(isConditionStartDateSearchTerm){
                        conditionTextList.push('开投日期(搜索词)');
                        if(!restCondition.includes('start_date')){
                            restCondition.push('start_date');
                        }
                    }

                    let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                    let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                    let htmlStr = `<div><p>关键词相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                    this.$confirm(htmlStr,'提示',{
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        customClass:'wide-confirm-box-550',
                    }).then(()=>{
                        console.log('继续');
                        this.lastSelectVal = val;
                        this.$emit('remove-apple-form',groupKeywordList.map(item=>item.name).concat(restGroup),conditionKeywordList.map(item=>item.name).concat(restCondition));

                    }).catch(()=>{
                        console.log('取消');
                        if(this.modalData.name=='start_date'){
                            this.$set(this.formItem,'start_date_dimension',this.lastSelectVal);
                        }else if(this.modalData.name=='create_date'){
                            this.$set(this.formItem,'create_date_dimension',this.lastSelectVal);
                        }else if(this.modalData.name=='yy_type'){
                            this.$set(this.formItem,'yy_type_dimension',this.lastSelectVal);
                        }
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
